/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const submitRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc',
  rpcName: 'submit',
  auth: 'app',
  fingerprint: 'SVH9-KSk7SiN2QNrn0kH7-je-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchForPortalRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc',
  rpcName: 'fetchForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA7YCiooNfnmuje-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dismissRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc',
  rpcName: 'dismiss',
  auth: 'app',
  fingerprint: 'pwammkBLT_uOUe2e_r4Xmeje-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc',
  rpcName: 'save',
  auth: 'app',
  fingerprint: 'XmFh2-HCD0WOUe2e_r4Xmeje-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchBySuggestionIdRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc',
  rpcName: 'fetchBySuggestionId',
  auth: 'app',
  fingerprint: '1w1ZzDedLQFnDnjqe7bNGuje-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};